import React, { Fragment } from "react";
import { formatDateTime } from "../../../../../utils/date";
import { colors } from "../../../../../utils/colors";

function OrderHistory({ item, color }) {
  return (
    <tr>
      <td className="residuesItem">
        {formatDateTime(item.datetime)
          .split(" ")
          .map((value, idx) => (
            <Fragment key={`order_history_date_${item.id}_${idx}`}>
              {idx > 0 && <br />}
              <span>{value}</span>
            </Fragment>
          ))}
      </td>
      <td className="residuesItem">
        <span
          style={{
            color: item.status?.technorama ? colors["technorama"] : colors["black"],
          }}
        >
          {item.title}
        </span>
      </td>
      <td className="residuesItem">
        <div className="d-flex">
          <div
            className="text-white text-xs text-center px-4 py-1"
            style={{
              borderRadius: 14,
              backgroundColor: color || colors["purple"],
            }}
          >
            {item.status?.title || item.body || ""}
          </div>
        </div>
      </td>
    </tr>
  );
}

export default OrderHistory;
